import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import classNames from "classnames";
import useOnClickOutside from "../../lib/hooks/use-on-click-outside";
import useOnKeyPress from "../../lib/hooks/use-on-key-press";
import Icon from "../Icon";
import Portal from "../Portal";
import style from "./style.module.scss";
export default function Modal(props) {
    const { id, isOpen = false, width, clickOutsideToCloseDisabled } = props;
    const requestCloseModal = () => {
        if (props.onClose) {
            props.onClose();
        }
    };
    const modalRef = useRef(null);
    useOnClickOutside(modalRef, () => {
        if (!clickOutsideToCloseDisabled) {
            requestCloseModal();
        }
    });
    useOnKeyPress(modalRef, requestCloseModal, "Escape");
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("modal-open");
            if (modalRef.current) {
                trapFocus(modalRef.current);
            }
        }
        else {
            document.body.classList.remove("modal-open");
        }
        // Always remove the modal-open class when the component unmounts
        return () => document.body.classList.remove("modal-open");
    }, [isOpen]);
    if (!isOpen) {
        return null;
    }
    const labelId = `${id}-label`;
    let containerFn;
    const defaultContainer = document.getElementById("speedcurve-modal-container");
    if (defaultContainer) {
        containerFn = () => defaultContainer;
    }
    return (_jsxs(Portal, { container: containerFn, children: [_jsx("div", { className: style["backdrop"], onClick: requestCloseModal }), _jsx("div", { className: classNames(style["modal-container"], "speedcurve-components"), children: _jsxs("div", { ref: modalRef, id: id, className: classNames(style["modal"], style["modal--" + width]), tabIndex: -1, "aria-labelledby": labelId, "aria-modal": "true", role: "dialog", children: [_jsxs("div", { className: style["modal-header"], children: [_jsx("h3", { id: labelId, className: style["modal-title"], children: props.title }), _jsx("button", { type: "button", className: style["close-button"], "data-dismiss": "modal", "aria-label": "Close", onClick: requestCloseModal, children: _jsx("span", { "aria-hidden": "true", children: _jsx(Icon, { name: "xmark" }) }) })] }), props.children] }) })] }));
}
function getFocusableElements(element) {
    return element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
}
function trapFocus(element) {
    const focusableEls = getFocusableElements(element);
    const firstFocusableEl = focusableEls[0];
    firstFocusableEl.focus();
    element.addEventListener("keydown", function (e) {
        const focusableEls = getFocusableElements(element);
        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];
        const KEYCODE_TAB = 9;
        const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            /* shift + tab */ if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } /* tab */
        else {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}
